/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserIdAddress } from './UserIdAddress';
import {
    UserIdAddressFromJSON,
    UserIdAddressFromJSONTyped,
    UserIdAddressToJSON,
} from './UserIdAddress';

/**
 * 
 * @export
 * @interface UserIdsAddressesResponse
 */
export interface UserIdsAddressesResponse {
    /**
     * 
     * @type {Array<UserIdAddress>}
     * @memberof UserIdsAddressesResponse
     */
    data?: Array<UserIdAddress>;
}

/**
 * Check if a given object implements the UserIdsAddressesResponse interface.
 */
export function instanceOfUserIdsAddressesResponse(value: object): value is UserIdsAddressesResponse {
    let isInstance = true;

    return isInstance;
}

export function UserIdsAddressesResponseFromJSON(json: any): UserIdsAddressesResponse {
    return UserIdsAddressesResponseFromJSONTyped(json, false);
}

export function UserIdsAddressesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserIdsAddressesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(UserIdAddressFromJSON)),
    };
}

export function UserIdsAddressesResponseToJSON(value?: UserIdsAddressesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(UserIdAddressToJSON)),
    };
}

